import PassengerDataRequest from "../../api/raily/passenger/data/passenger-data.request";
import passengerApiService from "../../api/raily/passenger/passenger-api.service";
import PassengerUpdateRequest from "../../api/raily/passenger/update/passenger-update.request";
import dataLoadErrorFactory from "../../utils/data-load-error/data-load-error.factory";
import handleErrorFactory from "../../utils/handle-error/handle-error.factory";
import HttpError from "../../utils/http/http.error";
import PassengerAddError from "./add/passenger-add-error";
import PassengerAddParams from "./add/passenger-add-params";
import passengerAddParamsFactory from "./add/passenger-add-params.factory";
import PassengerData from "./data/passenger-data";
import PassengerDataError from "./data/passenger-data-error";
import PassengerDataParams from "./data/passenger-data-params";
import passengerDataParamsFactory from "./data/passenger-data-params.factory";
import passengerDataFactory from "./data/passenger-data.factory";
import PassengerUpdateError from "./update/passenger-update-error";
import PassengerUpdateParams from "./update/passenger-update-params";
import passengerUpdateParamsFactory from "./update/passenger-update-params.factory";

const add = async (
  params: PassengerAddParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request = passengerAddParamsFactory.createRequest(params);

  try {
    const response = await passengerApiService().add(request, abortSignal);

    if (response.status !== 201) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | PassengerAddError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const update = async (
  params: PassengerUpdateParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: PassengerUpdateRequest =
    passengerUpdateParamsFactory.create(params);

  try {
    const response = await passengerApiService().update(request, abortSignal);

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | PassengerUpdateError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getData = async (
  params: PassengerDataParams,
  abortSignal: AbortSignal,
): Promise<PassengerData> => {
  const request: PassengerDataRequest =
    passengerDataParamsFactory.create(params);

  try {
    const response = await passengerApiService().getData(request, abortSignal);

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const passengerData: PassengerData = passengerDataFactory.create(response);

    return passengerData;
  } catch (_error) {
    const error = _error as HttpError | PassengerDataError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const passengerService = {
  add,
  update,
  getData,
};

export default passengerService;
